<template>
  <div
    :class="{'m-height-248':!transactions}"
    class="md-content md-table md-primary md-theme-default"
  >
    <div class="md-content md-table-content md-scrollbar md-theme-default">
      <table v-if="values.length>0" :key="i">
        <thead v-if="transactions">
          <tr>
            <th class="md-table-head md-table-cell-selection">
              <div class="md-table-head-container">
                <div class="md-table-head-label">
                  <div class="md-table-cell-container">
                    <md-checkbox @change="check_status(null,0)" v-model="all" class="md-primary"></md-checkbox>
                  </div>
                </div>
              </div>
            </th>
            <th class="md-table-head">
              <div class="md-table-head-container md-ripple md-disabled">
                <div class="md-table-head-label">
                  <!---->
                  TRX Date
                  <!---->
                </div>
              </div>
            </th>
            <th class="md-table-head">
              <div class="md-table-head-container md-ripple md-disabled">
                <div class="md-table-head-label">
                  <!---->
                  {{ $t('slip_specific.sender') }}
                  <!---->
                </div>
              </div>
            </th>
            <th class="md-table-head">
              <div class="md-table-head-container md-ripple md-disabled">
                <div class="md-table-head-label">
                  <!---->
                  Deposit Amount
                  <!---->
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in values"
            :key="index"
            class="md-table-row blue-cell md-has-selection"
          >
            <td class="md-table-cell md-table-cell-selection">
              <div class="md-table-cell-container">
                <md-checkbox
                  v-if="!filter"
                  @change="check_status(item.id,arr[item[get_object]])"
                  v-model="arr[item[get_object]]"
                  class="md-primary"
                ></md-checkbox>
                <md-checkbox
                  v-else
                  @change="check_status(item,arr[item])"
                  v-model="arr[item]"
                  class="md-primary"
                ></md-checkbox>
              </div>
            </td>
            <td v-if="!transactions" class="md-table-cell">
              <div v-if="!filter && object2" class="md-table-cell-container">{{item[object] + ' | ' + item[object2]}}</div>
              <div v-else-if="!filter && !object2" class="md-table-cell-container">{{item[object]}}</div>
              <div v-else class="md-table-cell-container">{{item}}</div>
            </td>
            <template v-else>
              <td class="md-table-cell">
                <div class="md-table-cell-container">{{item.date_issued}}</div>
              </td>
              <td class="md-table-cell">
                <div class="md-table-cell-container">{{item.sender}}</div>
              </td>
              <td class="md-table-cell">
                <div class="md-table-cell-container">{{(item.amount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}}</div>
              </td>
            </template>
          </tr>
        </tbody>
      </table>
      <empty-state noretry="1" class="mt-0 py-3 px-2" v-else></empty-state>
    </div>
  </div>
</template>
<script>
export default {
  props: ["values", "filter", "type", "name", "setvalues", "transactions"],
  data() {
    return {
      arr: [],
      object: "name",
      i: 0,
      url_selected: [],
      all: 0,
      object2: false
    };
  },
  computed: {
    get_arr() {
      return this.arr;
    },
    get_object() {
      if (!this.filter) {
        if (this.name == "agent_ids") return "agent_id";
        else return "id";
      } else {
        return "name";
      }
    }
  },
  created() {
    Event.$on("data_loaded", data => {
      this.all = 0;
    });

    //if values for selecting are passed
    if (this.setvalues) {
      this.setvalues.forEach(element => {
        this.arr[element.id] = true;
      });
    }

    if (this.type) {
      this.object = "description";
    }
    if (this.name == "bank_account_ids") {
      this.object = "acc_number";
    }
    if (this.name == "agent_ids") {
      this.object = "agent_id";
      this.object2 = "name";
    }
    setTimeout(() => {
      this.check();
    }, 1000);
  },
  methods: {
    check() {
      let ob1 = "id";
      let ob = "id";
      if (this.name == "filters") {
        this.url_selected = this.$route.query.fields;

        if (!this.url_selected) {
          return;
        }
        this.url_selected = JSON.parse(this.url_selected);

        this.url_selected = this.url_selected.additional;
        if (this.url_selected)
          this.url_selected = Object.keys(this.url_selected);
        else this.url_selected = [];
        //  console.log(this.url_selected);

        if (this.name != "filters") {
          if (this.name == "agent_ids") ob1 = "agent_id";
        } else {
          ob1 = "name";
        }
        this.values.forEach(element => {
          this.arr[element.id] = this.url_selected.includes(element[ob1])
            ? true
            : false;
        });
        this.select();
        return;
      }

      if (!this.filter) {
        this.url_selected = this.$route.query[this.name];

        if (!this.url_selected) {
          return;
        }
      } else {
        this.url_selected = this.$route.query.fields;

        if (!this.url_selected) {
          return;
        }
        this.url_selected = JSON.parse(this.url_selected);

        this.url_selected = this.url_selected.additional[this.name];
      }
      if (this.url_selected)
        this.url_selected = Object.values(JSON.parse(this.url_selected));
      else this.url_selected = [];

      this.arr = {};

      this.values.forEach(element => {
        if (!this.filter) {
          if (this.name == "agent_ids") ob = "agent_id";
          this.arr[element[ob]] = this.url_selected.includes(element[ob])
            ? true
            : false;
        } else {
          this.arr[element] = this.url_selected.includes(element)
            ? true
            : false;
        }
      });
      this.select();
    },

    existsID(id) {
      this.setvalues.forEach(element1 => {
        if (element1.id == id) return true;
      });

      return false;
    },
    check_status(id, status) {
      if(id===0&&status===false){
           //update the router params
      this.$router
        .push({
          path: this.$route.path
        })
        .catch(err => {});
      }
      //select all values
      if (id === null) {

        this.values.forEach(element => {
          this.arr[element.id] = this.all;
          if (!this.all) {
            this.$emit("unselect", element.id);
          }
        });
      }
      if (!status) {
        this.$emit("unselect", id);
      }
      this.select();
    },
    select() {
      let ob = "id";
      this.i++;
      let tmp = [];
      if (!this.filter) {
        if (this.name == "agent_ids") ob = "agent_id";
      } else ob = "name";
      if (!this.filter) tmp = this.values.filter(el => this.arr[el[ob]]);
      else {
        this.values.forEach(element => {
          if (this.arr[element]) {
            tmp.push({ name: element });
          }
        });
      }

      this.$emit("select", tmp);
    }
  }
};
</script>